import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotFoundComponent implements OnInit {
  public title = String('NOT_FOUND.TITLE');
  public description = String('NOT_FOUND.DESCRIPTION');

  constructor() {}

  ngOnInit(): void {}
}
